// extracted by mini-css-extract-plugin
export default {"section":"welcome_section__fLF1d","content":"welcome_content__vxdMN","imgbanner":"welcome_imgbanner__RUCVQ","img_desk":"welcome_img_desk__2gtVA","img_mob":"welcome_img_mob__Wsk9U"};